module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-3-c14bcca300e78424b146e2c9471323c7.png";